export default __webpack_public_path__ + "static/media/9.bff6a8ce.jpg";